import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'getIds',
    standalone: false
})
export class GetIdsPipe implements PipeTransform {

    transform(value: any, args?: any): string[] {
        return value ? Object.keys(value) : [];
    }
}
